// 経路検索→予約の場合のqueryの変換(発着駅)
export const getStationFromQuery = (id, id_type, stations) => {
  let station;
  switch (id_type) {
    case "mixway":
      station = stations.find((station) => station.mixway_code == id);
      break;
    case "mfitt":
      station = stations.find((station) => station.code == id);
      break;
  }
  return station != undefined ? station : {};
};
